import React from 'react'

const Loader = ({ fullScreen = true }) => {
    return fullScreen ? (
        <div className=" absolute top-0 left-0 bg-gray-400 opacity-30 h-screen w-screen flex justify-center items-center" style={{ zIndex: 99999 }}>
            <div className="loader"></div>
        </div>
    ) : (
        <div className="loader" style={{ width: '20px', height: '20px',borderWidth : "2px", borderTopWidth:"2px" }}></div>
    )
}

export default Loader
